import Toast from 'components/Toast';
import SERVICES from 'services';
import {Button, Form, Input} from 'antd';
import {useState} from 'react';
import {ltrim} from 'components/formItems/FormGroup/FormGroup';

const ForgotPassword = () => {
	const [inputErrors, setInputErrors] = useState({email: null});
	const [loading, setLoading] = useState(false);

	const onFinish = (data: any) => {
		setLoading(true);
		SERVICES.AUTH.forgotPassword(data)
			.then(() => {
				Toast.success('Reset link have been sent to your email');
			})
			.catch(err => {
				let errMessage = null;
				if (typeof err.message !== 'string') {
					errMessage = err.message;
				} else {
					Toast.error(err.message);
				}
				setInputErrors(errMessage);
			})
			.finally(() => {
				setLoading(false);
			});
	};

	return (
		<div className="formContainer">
			<div className="formContainer_title">
				<span>Վերականգնել Գաղտնաբառը</span>
				<div id="divider" />
			</div>
			<Form className="formContainer_form" layout="vertical" onFinish={onFinish} autoComplete="off">
				<Form.Item
					name="email"
					validateStatus={!!inputErrors?.email ? 'error' : undefined}
					getValueFromEvent={(val: any) => ltrim(val.target.value)}
					help={inputErrors?.email}
					rules={[{required: true, message: 'Խնդրում ենք մուտքագրե՛ք ձեր էլ․ փոստը'}]}>
					<Input placeholder="Էլ․ փոստ" className="formContainer_form_input" />
				</Form.Item>

				<Form.Item style={{textAlign: 'center'}}>
					<Button
						className="formContainer_form_button"
						type="primary"
						htmlType="submit"
						loading={loading}>
						Վերականգնել
					</Button>
				</Form.Item>
			</Form>
			<div className="formContainer_footer">
				<span>Հիշեցի՞ք Ձեր գաղտնաբառը։</span>
				<a href="/login">Մուտք գործել</a>
			</div>
		</div>
	);
};

export default ForgotPassword;
